export default {
  metadata: {
    version: '1.0.0',
    id: 'file-uploader-1.0.0',
    name: 'JDSFileUploader'
  },
  hierarchy: {
    container: ['jds_file_uploader_control', 'jds_file_uploader_panel']
  },
  base: {
    container: {
      'flex-direction': '{f_0}',
      'justify-content': '{f_1}',
      'align-items': '{f_2}',
      width: '{f_3}',
      gap: '{f_4}',
      opacity: '{f_5}'
    }
  },
  variant: {
    kind: {
      collapsible: {
        jds_file_uploader_panel: {
          kind: 'collapsible'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      kind: {
        type: 'JDSFileUploaderPanel.kind',
        values: ['classic', 'collapsible']
      },
      expanded: {
        values: [false, true]
      },
      showDivider: {
        values: [true, false]
      }
    },
    data: {
      jds_file_uploader_control: {
        label: {
          type: 'string',
          name: 'label'
        },
        helperText: {
          type: 'string',
          name: 'helperText'
        },
        uploadButtonLabel: {
          type: 'string',
          name: 'uploadButtonLabel'
        }
      },
      jds_file_uploader_panel: {
        message: {
          type: 'string',
          name: 'message'
        },
        value: {
          type: 'float',
          name: 'value'
        },
        showDivider: {
          type: 'boolean',
          name: 'showDivider'
        },
        expanded: {
          type: 'boolean',
          name: 'expanded'
        },
        items: {
          type: 'list',
          name: 'items',
          object: {
            state: 'JDSFileUploaderItem.state',
            message: 'string'
          }
        }
      }
    },
    events: {
      jds_file_uploader_control: {
        onInfoClick: 'onInfoClick',
        onClick: 'onClick'
      },
      jds_file_uploader_panel: {
        onClick: 'onExpand',
        onClose: 'onClose'
      }
    },
    a11y: {
      jds_file_uploader_control: {
        properties: {
          uploadButtonAriaLabel: 'uploadButtonAriaLabel'
        }
      },
      jds_file_uploader_panel: {
        properties: {
          panelAriaLabel: 'panelAriaLabel',
          panelAriaDescribedBy: {
            name: 'panelAriaDescribedBy',
            platform: 'web,ios'
          },
          panelSuffixAriaLabel: 'panelSuffixAriaLabel'
        },
        name: 'items',
        repeating: {
          ariaLabel: 'itemAriaLabel',
          ariaDescribedby: {
            name: 'itemAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
